import ReactECharts from "echarts-for-react";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  getCurrentFinancialYear,
  previousFinancialYear,
} from "../../../../utils/commonFunctions";
import DataGraph from "../../../commons/Graphs/DataGraph";
import { GrayIButton } from "../../../../assets/images";
import { Link } from "react-router-dom";

type AppProps = {
  tableHeader: any;
  data: any;
  changeYear: boolean;
  history: any;
  preData: boolean;
  activeTab: string;
  currency: string | undefined;
  selectYear?: string | null;
  compareTo?: string | null;
};

const NameAndTrade = ({
  tableHeader,
  data,
  changeYear,
  history,
  preData,
  activeTab,
  selectYear,
  currency,
  compareTo,
}: AppProps) => {
  const clientCode = history?.location?.state?.client_code;
  const companyName = history?.location?.state?.company_name;
  const startDate = changeYear
    ? `${selectYear && selectYear.split("-")[0]}-04-01`
    : `${compareTo && compareTo.split("-")[0]}-04-01`;
  const endDate = changeYear
    ? `${selectYear && selectYear.split("-")[1]}-03-31`
    : `${selectYear && selectYear.split("-")[1]}-03-31`;

  const finalRedirectLink = {
    pathname: `/reports/${clientCode}/ledger-statement?client_code=${clientCode}&company_name=${companyName}`,
  };
  const handleSetLocalStorageData = (ledgerId: number) => {
    localStorage.setItem("ledger_id", ledgerId.toString());
    localStorage.setItem("start_date", startDate);
    localStorage.setItem("end_date", endDate);
  };
  let hash = history?.location?.hash?.replace(/[^\w\s]/gi, "");
  const [showGraph, setShowGraph] = useState(false);
  const [graphData, setGraphData] = useState<any>({});

  function options(el: any, pre_data1: any) {
    let arr: any = [];
    let arr1: any = [];

    el?.length > 0 &&
      el.map((dataView: any) => {
        arr.push(dataView?.total_amount);
      });
    pre_data1?.length > 0 &&
      pre_data1.map((dataView: any) => {
        arr1.push(dataView?.total_amount);
      });

    let option;
    return (option = {
      xAxis: {
        show: false,
        type: "category",
      },

      yAxis: {
        show: false,
        type: "value",
      },
      grid: {
        top: "10%",
        bottom: "12px",
        width: "75px",
        height: "36px",
      },
      series: [
        {
          type: "line",
          // smooth: true,
          symbol: "none",

          lineStyle: {
            color:
              activeTab === "sales" && changeYear
                ? "#32bc6b"
                : activeTab === "sales" && !changeYear
                ? "#7c8db0"
                : activeTab != "sales" && changeYear
                ? "#e7733e"
                : "#7c8db0",
            // "#A3701C",//a3 dark experience
            width: 2.5,
          },
          areaStyle: {
            opacity: 0.2,
            color:
              activeTab === "sales" && changeYear
                ? "#32bc6b"
                : activeTab === "sales" && !changeYear
                ? "#7c8db0"
                : activeTab != "sales" && changeYear
                ? "#e7733e"
                : "#7c8db0",
          },
          data: arr,
        },
        arr1 && {
          type: "line",
          // smooth: true,
          symbol: "none",
          areaStyle: {
            opacity: 0.2,
            color:
              activeTab === "sales" && !changeYear
                ? "#32bc6b"
                : activeTab === "sales" && changeYear
                ? "#7c8db0"
                : activeTab != "sales" && !changeYear
                ? "#e7733e"
                : "#7c8db0",
          },

          lineStyle: {
            color:
              activeTab === "sales" && !changeYear
                ? "#32bc6b"
                : activeTab === "sales" && changeYear
                ? "#7c8db0"
                : activeTab != "sales" && !changeYear
                ? "#e7733e"
                : "#7c8db0",
            // color: activeTab === "sales"&&changeYear ? "#9ECE38" : "#F9B442",
            width: 2.5,
          },
          data: arr1,
        },
      ],
    });
  }

  const openGraphModel = (data: any) => {
    const values = {
      name: data?.ledger_name,
      data: data?.current_year_monthly_data,
      Previous_data: data.prev_year_monthly_data,
    };
    setGraphData(values);
  };

  const showGraphInModel = () => {
    setShowGraph((prv) => !prv);
  };

  const renderLedgerNameToolTip = (props: any, ledgerName: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {ledgerName}
      </Tooltip>
    );
  };
  const renderNoDataInfo = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        you don't have enough data to see the trend.
      </Tooltip>
    );
  };

  const tooltipLedgerName = (
    ledgerName: string,
    tooltipLedgerNmae: string,
    id: number
  ) => {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 250 }}
        overlay={renderLedgerNameToolTip("", tooltipLedgerNmae)}
      >
        <td
          style={{
            textAlign: "left",
            minWidth: "250px",
          }}
        >
          <Link
            target="_blank"
            to={finalRedirectLink}
            onClick={() => handleSetLocalStorageData(id)}
            style={{ textDecoration: "none", cursor: "pointer" }}
          >
            <span
              style={{
                textDecoration: "underline",
                fontSize: "14px",
                textUnderlineOffset: "0.3em",
                color: "#262a44",
                fontWeight: "600",
                marginRight: "35px",
              }}
            >
              {ledgerName}
            </span>
          </Link>
        </td>
      </OverlayTrigger>
    );
  };

  const renderTableData = () => {
    const finalTableData =
      data?.length > 0 &&
      data?.map((dataItem: any, index: number) => {
        const ledgerName =
          dataItem?.ledger_name?.length > 40
            ? `${dataItem?.ledger_name?.slice(0, 40)}...`
            : dataItem?.ledger_name;
        return (
          <>
            <tr
              style={{ background: index === data.length - 1 ? "#ccccd1" : "" }}
            >
              {dataItem?.ledger_name?.length > 40 ? (
                tooltipLedgerName(
                  ledgerName,
                  dataItem?.ledger_name,
                  dataItem?.ledger_id
                )
              ) : (
                <td
                  style={{
                    textAlign: "left",
                    minWidth: "250px",
                  }}
                >
                  <Link
                    target="_blank"
                    to={finalRedirectLink}
                    onClick={() =>
                      handleSetLocalStorageData(dataItem?.ledger_id)
                    }
                    style={{ textDecoration: "none", cursor: "pointer" }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        fontSize: "14px",
                        textUnderlineOffset: "0.3em",
                        color: "#262a44",
                        fontWeight: "600",
                        marginRight: "35px",
                      }}
                    >
                      {dataItem?.ledger_name}
                    </span>
                  </Link>
                </td>
              )}
              <td
                style={{
                  width: "200px",
                  height: "60px",
                  padding:
                    !preData &&
                    changeYear &&
                    dataItem?.current_year_monthly_data?.length === 1
                      ? "0.6rem"
                      : "0px",
                }}
                onClick={() => (
                  <>
                    {showGraphInModel()} {openGraphModel(dataItem)}
                  </>
                )}
              >
                {!preData &&
                changeYear &&
                dataItem?.current_year_monthly_data?.length === 1 ? (
                  <>
                    NA{" "}
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={renderNoDataInfo}
                    >
                      <img src={GrayIButton} alt="info" />
                    </OverlayTrigger>
                  </>
                ) : (
                  <ReactECharts
                    option={options(
                      dataItem?.current_year_monthly_data?.length === 0
                        ? dataItem?.prev_year_monthly_data
                        : changeYear
                        ? dataItem?.current_year_monthly_data
                        : dataItem?.prev_year_monthly_data,
                      preData && changeYear
                        ? dataItem?.prev_year_monthly_data
                        : preData && changeYear === false
                        ? dataItem?.current_year_monthly_data
                        : []
                    )}
                    style={{
                      width: "100px",
                      height: "42px",
                      position: "relative",
                      top: "10%",
                      bottom: "10%",
                    }}
                  />
                )}
              </td>
            </tr>
          </>
        );
      });

    return finalTableData;
  };

  return (
    <>
      {renderTableData()}
      {showGraph && (
        <Modal isOpen={showGraph} size="lg">
          <ModalHeader
            toggle={showGraphInModel}
            className="pt-4 pl-4"
            style={{ paddingBottom: 0, border: "none" }}
          >
            <div style={{ lineHeight: 1.1, marginLeft: "20px" }}>
              <span style={{ fontSize: "19px", fontWeight: "bolder" }}>
                {graphData?.name}
              </span>
              <div>
                <span
                  className="mt-2 mb-2"
                  style={{ fontSize: "16px", color: "#4e4b66" }}
                >
                  Below data is for{" "}
                  {data[0]?.current_year_monthly_data?.length === 0
                    ? `FY ${compareTo}`
                    : `${
                        preData
                          ? `FY  
                     ${selectYear} vs FY
                    ${compareTo}`
                          : `${changeYear ? "FY" : "FY"}   ${
                              changeYear ? selectYear : compareTo
                            }`
                      }`}
                </span>

                {preData ? (
                  <>
                    <div
                      style={{
                        fontSize: "15px",
                      }}
                      className="d-flex mt-3 mb-2"
                    >
                      <div
                        className="mr-2"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor:
                            activeTab === "sales" ? "#32bc6b" : "#e7733e",
                        }}
                      ></div>
                      &nbsp;
                      <span>
                        FY &nbsp;
                        {selectYear}
                      </span>
                      &nbsp;
                      <div
                        className="ml-3"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor:
                            activeTab === "sales" ? "#7c8db0" : "#7c8db0",
                        }}
                      ></div>
                      &nbsp;
                      <span className="ml-2">
                        FY &nbsp;
                        {compareTo}
                      </span>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                    className="d-flex mt-3 mb-2"
                  >
                    <div
                      className="mr-2"
                      style={{
                        width: "16px",
                        height: "16px",
                        backgroundColor:
                          (hash === "sales" && changeYear) ||
                          (hash === "" && changeYear)
                            ? "#32bc6b"
                            : hash != "sales" && changeYear
                            ? "#e7733e"
                            : "#7c8db0",
                      }}
                    ></div>
                    <span>
                      {data[0]?.current_year_monthly_data?.length === 0
                        ? `FY ${compareTo}`
                        : changeYear
                        ? `FY ${selectYear}`
                        : `FY ${compareTo}`}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <DataGraph
              data={graphData}
              currency={currency}
              pre_data={preData}
              yAxisName={
                hash === "sales" || hash === ""
                  ? "Total Sales"
                  : "Total Expenses"
              }
              xAxisName={
                data[0]?.current_year_monthly_data?.length === 0
                  ? `FY ${compareTo}`
                  : preData
                  ? `FY ${selectYear} vs FY ${compareTo}`
                  : `${changeYear ? "FY" : "FY"} ${
                      changeYear ? selectYear : compareTo
                    }`
                //  `FY ${ changeYear? selectYear:compareTo}`
              }
              activeTab={activeTab}
              changeYear={changeYear}
              selectYear={selectYear}
              compareTo={compareTo}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default NameAndTrade;
